/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useEffect, useRef } from "react";
import { Text, Button, Icon } from "@bookingcom/bui-react";

import { useI18n, t } from "@bookingcom/lingojs-react";

import { CloseIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { UIPOSMismatch } from "@flights/types";
import useTranslatedCountryNames from "../../../hooks/useTranslatedCountryNames";
import Frame from "../Frame";
import styles from "./POSMisMatch.module.css";

interface Props {
  goToSearch: () => void;
  POSMismatch: UIPOSMismatch;
}

const POSMisMatch: React.FunctionComponent<Props> = (props: Props) => {
  const { goToSearch, POSMismatch } = props;
  const i18n = useI18n();
  const focusElementRef = useRef<HTMLDivElement>(null);
  const { getCountryName, getCountryNameFrom, getCountryNameArticle, getCountryNameIn } = useTranslatedCountryNames();

  useEffect(() => {
    focusElementRef.current?.focus?.();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Frame p={4} attributes={{ role: "alertdialog" }}>
      <div className={styles.header}>
        <div
          className={styles.headerCloseButton}
          onClick={goToSearch}
          ref={focusElementRef}
          tabIndex={0}
          aria-label={i18n.trans(t("close"))}
          role="button"
        >
          <Icon svg={CloseIcon} size="medium"></Icon>
        </div>

        <Text variant="headline_2" className={styles.headerText} attributes={{ tabIndex: 0, role: "heading" }}>
          {i18n.trans(
            t("flights_meta_different_pos_detected_header", {
              variables: {
                country_name_from: getCountryNameFrom(POSMismatch.detectedPointOfSale),
                name_article: getCountryNameArticle(POSMismatch.detectedPointOfSale),
                country_name: getCountryName(POSMismatch.detectedPointOfSale)
              }
            })
          )}
        </Text>
      </div>
      <>
        <Frame>
          <Text variant="body_1" attributes={{ tabIndex: 0 }}>
            {i18n.trans(
              t("flights_meta_different_pos_detected_sub_head", {
                variables: {
                  country_name_in: getCountryNameIn(POSMismatch.detectedPointOfSale),
                  name_article: getCountryNameArticle(POSMismatch.detectedPointOfSale),
                  country_name: getCountryName(POSMismatch.detectedPointOfSale)
                }
              })
            )}
          </Text>
        </Frame>
        <>
          <div className={styles.footerSpacer}></div>

          <Frame className={styles.footer}>
            <Button
              variant="primary"
              text={i18n.trans(t("flights_meta_different_pos_detected_cta"))}
              size="large"
              onClick={goToSearch}
              wide
            />
          </Frame>
        </>
      </>
    </Frame>
  );
};
export default POSMisMatch;
